module.exports = __webpack_public_path__ + "assets/upload.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upload.png
// module id = 1673
// module chunks = 7